import { useState } from 'react';
import { Box, Typography, Alert } from '@mui/material';
import ConfigCard from '../shared/ConfigCard';
import useOldProtocolsStatuses from '../../hooks/useOldProtocolsStatuses';

function OldProtocolsTab() {
  const { 
    oldProtocolsStatuses, 
    error: statusError,
    updateStatus 
  } = useOldProtocolsStatuses();
  
  const [loadingOldProtocols, setLoadingOldProtocols] = useState({});
  const [oldProtocolsError, setOldProtocolsError] = useState(null); 

  const handleOldProtocolsToggle = async (oldProtocolName) => {
    setOldProtocolsError(null);
    const isCurrentlyEnabled = oldProtocolsStatuses[oldProtocolName]?.enabled;

    setLoadingOldProtocols(prev => ({ 
      ...prev, 
        [oldProtocolName]: true 
    }));

    const success = await updateStatus(oldProtocolName, !isCurrentlyEnabled);
    
    if (!success) {
      setOldProtocolsError(`Failed to ${isCurrentlyEnabled ? 'disable' : 'enable'} ${oldProtocolName}`);
    }
    
    setLoadingOldProtocols(prev => ({ 
      ...prev, 
      [oldProtocolName]: false 
    }));
  };


  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>
        Old Protocols Configurations
      </Typography>
      
      {(oldProtocolsError || statusError) && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {oldProtocolsError || statusError}
        </Alert>
      )}
      
      <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
        General Configurations
      </Typography>
      {Object.keys(oldProtocolsStatuses)
        .map((oldProtocolName) => (
          <ConfigCard
            key={oldProtocolName}
            title={oldProtocolName}
            enabled={oldProtocolsStatuses[oldProtocolName]?.enabled || false}
            loading={loadingOldProtocols[oldProtocolName]}
            onToggle={() => handleOldProtocolsToggle(oldProtocolName)}
          />
        ))}
    </Box>
  );
}

export default OldProtocolsTab;